const state = {
  status: {
    fetching: [],
    errors: []
  },
  data: {
    podcasts: {},
    episodes: {}
  }
}

export default state
